module.exports = __webpack_public_path__ + "static/detecht-env1@2x-a151357ce72a5fa554dc800427a35ff3.png";